import { applicationStates } from '/business/shared/util/Statics';

export const isReductionPlanEditable = (appState?: string | null) => {
  if (!appState) {
    return false;
  }
  return [
    applicationStates.DRAFT,
    applicationStates.COMPLETED,
    applicationStates.REVIEWED,
    applicationStates.APPROVED,
    applicationStates.SUBMITTED,
    applicationStates.OFFERDECLARED,
    applicationStates.CONFIRMED,
    applicationStates.SIGNED,
  ].includes(appState);
};

// If you define the empty array inside a selector it may cause re-renders
// due to the array being a new reference each time.
export const EMPTY_ARRAY: never[] = [];
